<template>
  <v-container :class="$style.phoneContainer">

    <div :class="$style.phoneField">
      <InputField :class="[$style.phoneNumber, {[$style.inputError] : error}]"
                  v-model="phoneNumber"
                  :disabled="disabled"
                  type="tel"
                  mask="phone"
                  placeholder="(###) ###-####"/>
      <p v-if="error"
         :class="$style.errorMessage">
        {{ error }}
      </p>
    </div>


    <v-container :class="$style.buttonsContainer">
      <v-flex :class="$style.flexContainer">
        <v-btn
          v-for="value of buttonsValue"
          :key="value"
          :class="$style.digitButton"
          :disabled="disabled"
          color="#3BB247"
          fab
          @click="addDigit(value)"
        >{{ value }}</v-btn>
        <v-btn
          :class="$style.digitButton"
          :disabled="disabled"
          color="#3BB247"
          fab
          @click="removeDigit()"
        ><i class="material-icons">
          backspace
        </i></v-btn>
      </v-flex>
    </v-container>
  </v-container>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import InputField from '@/components/InputField';
import { Watch } from 'vue-property-decorator';

/**
 * Phone component with phone view and digit buttons.
 */
@Component({
  components: {
    InputField,
  },
  props: {
    value: {
      type:    String,
      default: '',
    },
    error: {
      type:    String,
      default: null,
    },
    disabled: {
      type:    Boolean,
      default: false,
    },
  },
})
export default class Phone extends Vue {
  phoneNumber = '';
  buttonsValue = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '0' ];

  /**
   * When props is changed - update phoneNumber in component
   * @param value - new value of prop
   */
  @Watch('value', { immediate: true })
  valueChanged(value) {
    this.phoneNumber = value;
  }

  /**
   * When phoneNumber is changed - notify parent about it
   * @param phone - new phone value
   */
  @Watch('phoneNumber')
  phoneChanged(phone) {
    this.$emit('input', phone);
  }

  addDigit(value) {
    if (this.phoneNumber.length < 10) {
      this.phoneNumber += value;
    }
  }

  removeDigit() {
    this.phoneNumber = this.phoneNumber.slice(0, this.phoneNumber.length - 1);
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";
.phoneContainer {
  width: 608px;
  padding: 0;
}

.phoneContainer .phoneField .phoneNumber input {
  text-align: center;
  font-size: 56px;
  line-height: 58px;
  font-weight: 300;
  max-height: none;
  padding-bottom: 30px;
}

.phoneContainer .phoneField .phoneNumber.inputError > div > div::before {
  border-color: $red-color;
}

.errorMessage {
  color: $red-color;
  font-size: 24px;
  line-height: 29px;
  font-style: italic;
  text-align: center;
  margin-top: -10px;
}

.buttonsContainer {
  margin: 50px 80px 0;
  width: calc(100% - 160px);
  padding: 0;
}

.flexContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  min-width: 280px;
  padding: 5% 10%;
}

.digitButton {
  min-width: 20px;
  width: 26%;
  margin: 3.5%;
  padding: 0 0 26%;
  position: relative;
  height: 0;
  font-size: 50px;
  font-weight: 300;
  div {
    color: $white;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    i {
      font-size: 40px;
    }
  }
}

@media (max-width: 600px) {
  .phoneNumber input {
    font-size: 36px;
    line-height: 38px;
  }

  .digitButton {
    font-size: 40px;
    div i {
      font-size: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/Phone.vue